import {
    Calendar
} from "lucide-react";

function UpcomingBookingHeader({
    count
}) {

    return (

        <div style={styles.header}>

            <div style={styles.titleRow}>

                <Calendar
                    size={36}
                    color="#00ff88"
                />

                <div>

                    <h1 style={styles.title}>
                        Upcoming Bookings
                    </h1>

                    <p style={styles.subtitle}>
                        {count} upcoming booking
                        {count !== 1 ? "s" : ""}
                    </p>

                </div>

            </div>

        </div>
    );
}

const styles = {

    header: {

        marginBottom: "32px",
    },

    titleRow: {

        display: "flex",

        alignItems: "center",

        gap: "16px",
    },

    title: {

        color: "#fff",

        fontSize: "38px",

        margin: 0,
    },

    subtitle: {

        color: "#cbd5e1",

        marginTop: "6px",
    },
};

export default UpcomingBookingHeader;